<template>
  <div class="invoice">

    <div v-if="preview" class="invoice-preview">preview</div>

    <div class="invoice-row">
      <div class="invoice-address">
        <slot name="invoice_to_address"/>
      </div>
      <!-- <div class="invoice-logo">
        <slot name="invoice_logo"/>
      </div> -->
    </div>

    <div class="invoice-row">
      <div class="invoice-address">
        <slot name="invoice_from_address"/>
      </div>
      <div class="invoice-meta-info">
        <slot name="invoice_meta_info"/>
      </div>
    </div>

    <div class="invoice-row">
      <div class="invoice-headline">
        <slot name="invoice_headline"/>
      </div>
      <div class="invoice-qr-info">
        <!-- Detailed information <br> -->
        <slot name="invoice_qr_info"/>
      </div>
    </div>

    <div class="invoice-row">
      <div class="invoice-content">
        <div class="invoice-content-header">
          <div class="invoice-70"></div>
          <div class="invoice-10 invoice-text-right">VAT%</div>
          <div class="invoice-20 invoice-text-right">Sum (VAT 0%)</div>
        </div>
        <slot name="invoice_content"/>
      </div>
    </div>

    <div class="invoice-row">
      <div class="invoice-content-footer">
        <slot name="invoice_content_footer"/>
      </div>
      <div class="invoice-qr-pay">
        <!-- Pay the invoice <br> -->
        <slot name="invoice_qr_pay"/>
      </div>
    </div>

    <div class="invoice-row">

    </div>

    <!-- TODO: can this "invoice-signature-line" be conditional on the slot?  -->
    <div class="invoice-row">
      <div class="invoice-signature">
        <hr class="invoice-signature-line">
        <slot name="invoice_signature"/>
      </div>
    </div>

    <div class="invoice-row">
      <div>
        <slot name="invoice_footer_upper_row"/>
      </div>
    </div>

    <div class="invoice-row invoice-footer">
      <div class="invoice-left-footer">
        <slot name="invoice_left_footer"/>
      </div>
      <div class="invoice-middle-footer">
        <slot name="invoice_middle_footer"/>
      </div>
      <div class="invoice-right-footer">
        <slot name="invoice_right_footer"/>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  props: [ 'preview' ]
}
</script>

<style lang="css" scoped>
.invoice {
  zoom: 0.7;
  width: 210mm;
  font-size: 4mm;
  background-color: white;
  color: black;
  padding: 10px 20px;
}

.invoice-preview {
  position: absolute;
  z-index: 100;
  color: red;
  transform: rotate(45deg);
  margin-top: 20%;
  margin-left: 20%;
  font-size: 500%;
  opacity: 0.25;
  font-weight: 100;
}

.invoice-row {
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 6mm;
}

.invoice-row-right {
  display: flex;
  justify-content: flex-end;
  width: 100%;
  margin-bottom: 6mm;
}

.invoice-logo {
  height: 128px;
  width: 128px;
  background-color: #cdcdcd;
}

.invoice-content-header {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.invoice-70 {
  width: 70%;
}

.invoice-20 {
  width: 20%;
}

.invoice-10 {
  width: 10%;
}

.invoice-text-right {
  text-align: right;
}

.invoice-address {
  line-height: 4mm;
}

.invoice-meta-info {
  line-height: 4mm;
}

.invoice-headline {
  font-weight: bold;
}

.invoice-number {
  font-weight: bold;
}

.invoice-qr-info {
  /* font-size: 4mm; */
}

.invoice-qr-info div {
  float: right;
}

.invoice-content {
  width: 100%;
}

.invoice-content-footer {

}

.invoice-signature {

}

.invoice-signature-line {
  width: 50mm;
  margin-top: 50px;
  margin-bottom: 15px;
}

.invoice-qr-pay {
  /* font-size: 5mm; */
}

.invoice-qr-pay div {
  float: right;
}

.invoice-footer {
  color: grey;
  font-size: 3mm;
}

.invoice-left-footer textarea,
.invoice-middle-footer textarea,
.invoice-right-footer textarea,
{
  width: 100%;
  min-height: 50mm;
  resize: none;
  overflow: hidden;
}
</style>
